<ng-container *transloco="let t; read: 'devices.detail.services'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <form [formGroup]="serviceForm" class="xs12col">
        <div class="fieldsetWrapper">
          <fieldset class="fieldsetContainer flexRow">
            <div class="titleAdd">
              <h2 class="xs12col padding-right-small">{{ t('title') }}</h2>
              <button
                kendoButton
                class="addIcon small"
                (click)="openServiceDialog()"
                loadingIndication="/services/createService"
                [hidden]="!('Permissions.Services.Create' | permission)"
                [disabled]="vm.openService">
                <span class="icon">
                  <img src="../../../assets/icons/add-icon.svg">
                </span>
              </button>
              <button
                kendoButton
                class="addIcon small"
                (click)="openClientServiceDialog()"
                loadingIndication="/services/createClientService"
                [hidden]="!('Permissions.ClientServices.Create' | permission) || ('Permissions.Services.Create' | permission)">
                <span class="icon">
                  <img src="../../../assets/icons/add-icon.svg">
                </span>
              </button>
            </div>
            <!-- Dialog for normal service -->
            @if (servicesOpened) {
              <kendo-dialog
                title="{{ editingService ? t('update') : t('create') }}"
                (close)="closeServiceDialog('cancel')"
                [minWidth]="250"
                [width]="450">
                <form [formGroup]="serviceForm" class="flexColumn">
                  <kendo-formfield>
                    <kendo-label [for]="description" [text]="t('description')"></kendo-label>
                    <kendo-textarea
                      kendoTextBox
                      type="text"
                      [rows]="4"
                      class="mbs"
                      formControlName="description"
                      #description>
                    </kendo-textarea>
                  </kendo-formfield>
                  <kendo-formfield [hidden]="true">
                    <kendo-label [text]="t('deviceWear')"></kendo-label>
                    <kendo-dropdownlist
                      [data]="deviceWear"
                      textField="text"
                      valueField="value"
                      [readonly]="true"
                      [defaultItem]="{ value: null, text: t('chooseWear') }"
                      formControlName="deviceWear"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-formfield [hidden]="true">
                    <kendo-label [text]="t('devicePollution')"></kendo-label>
                    <kendo-dropdownlist
                      [data]="devicePollution"
                      textField="text"
                      valueField="value"
                      [readonly]="true"
                      [defaultItem]="{ value: null, text: t('choosePollution') }"
                      formControlName="devicePollution"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-formfield>
                    <kendo-label text="{{ t('dateScheduled') }}*">
                      <kendo-datepicker
                        formControlName="dateScheduled"
                        placeholder="{{ t('date.placeholder') }}"
                        required>
                      </kendo-datepicker>
                    </kendo-label>
                  </kendo-formfield>
                  <kendo-formfield [hidden]="true">
                    <kendo-label text="{{ t('dateExecuted') }}">
                      <kendo-datepicker
                        [readonly]="true"
                        formControlName="dateExecuted"
                        placeholder="{{ t('date.placeholder') }}">
                      </kendo-datepicker>
                    </kendo-label>
                  </kendo-formfield>
                  <kendo-dialog-actions>
                    <button
                      [disabled]="serviceForm.invalid || !serviceForm.dirty"
                      type="submit"
                      kendoButton
                      (click)="submitServiceCreation()"
                      class="buttonPrimary">
                      {{ editingService ? tGlobal('save') : t('submit') }}
                    </button>
                    <button
                      kendoButton
                      (click)="closeServiceDialog('no')"
                      class="buttonSecondary">
                      {{t('cancel')}}
                    </button>
                    <button
                      kendoButton
                      class="buttonSecondary"
                      (click)="deletionDialogOpen()"
                      [hidden]="!editingService || !('Permissions.Services.Delete' | permission)">
                      <img src="../../../assets/icons/delete-icon.svg">
                    </button>
                  </kendo-dialog-actions>
                </form>
              </kendo-dialog>
            }
            <!-- Dialog for client service -->
            @if (clientServicesOpened) {
              <kendo-dialog
                title="{{ editingClientService ? t('update') : t('create') }}"
                (close)="closeClientServiceDialog('cancel')"
                [minWidth]="250"
                [width]="450">
                <form [formGroup]="clientServiceForm" class="flexColumn">
                  <kendo-formfield>
                    <kendo-label [for]="description" [text]="t('description')"></kendo-label>
                    <kendo-textarea
                      kendoTextBox
                      type="text"
                      [rows]="4"
                      class="mbs"
                      formControlName="description"
                      #description>
                    </kendo-textarea>
                  </kendo-formfield>
                  <kendo-formfield>
                    <kendo-label text="{{ t('dateExecuted') }}">
                      <kendo-datepicker
                        formControlName="dateExecuted"
                        placeholder="{{ t('date.placeholder') }}">
                      </kendo-datepicker>
                    </kendo-label>
                  </kendo-formfield>
                  <kendo-dialog-actions>
                    <button
                      [disabled]="clientServiceForm.invalid || !clientServiceForm.dirty"
                      type="submit"
                      kendoButton
                      (click)="submitClientServiceCreation()"
                      class="buttonPrimary">
                      {{ editingClientService ? tGlobal('save') : t('submit') }}
                    </button>
                    <button
                      kendoButton
                      (click)="closeClientServiceDialog('no')"
                      class="buttonSecondary">
                      {{t('cancel')}}
                    </button>
                    <button
                      kendoButton
                      class="buttonSecondary"
                      (click)="deletionClientDialogOpen()"
                      [hidden]="!editingClientService || !('Permissions.ClientServices.Delete' | permission)">
                      <img src="../../../assets/icons/delete-icon.svg">
                    </button>
                  </kendo-dialog-actions>
                </form>
              </kendo-dialog>
            }
            <!-- deletion dialog normal -->
            @if (deletionDialogOpened) {
              <kendo-dialog
                title="{{t('confirmDeletion')}}"
                (close)="deletionDialogClose('cancel')"
                [minWidth]="250"
                [width]="450">
                <p style="margin: 30px; text-align: center;">
                  {{t('deletionMessage')}}
                </p>
                <kendo-dialog-actions>
                  <button kendoButton (click)="deletionDialogClose('cancel')">{{ t('cancel') }}</button>
                  <button kendoButton (click)="deletionDialogClose('delete')" themeColor="primary">{{ t('delete') }}
                  </button>
                </kendo-dialog-actions>
              </kendo-dialog>
            }
            <!-- deletion dialog client -->
            @if (deletionClientDialogOpened) {
              <kendo-dialog
                title="{{t('confirmDeletion')}}"
                (close)="deletionClientDialogClose('cancel')"
                [minWidth]="250"
                [width]="450">
                <p style="margin: 30px; text-align: center;">
                  {{t('deletionMessage')}}
                </p>
                <kendo-dialog-actions>
                  <button kendoButton (click)="deletionClientDialogClose('cancel')">{{ t('cancel') }}</button>
                  <button kendoButton (click)="deletionClientDialogClose('delete')" themeColor="primary">{{ t('delete') }}
                  </button>
                </kendo-dialog-actions>
              </kendo-dialog>
            }
            @for (service of vm.services; track service) {
              <div class="xs12col serviceWrapper">
                <div class="serviceContainer" [ngClass]="{'success': service.type != 20 && service.status == 20, 'failed': service.type != 20 && service.status == 30, 'client': service.type == 20}">
                  <div class="content">
                    <p>
                      {{ service.description }}
                    </p>
                  </div>
                  <div class="footer xs12col">
                    <div class="firstCol">
                      <div class="dateContainer">
                        @if (service.dateExecuted == null) {
                          <span class="small"><img src="../../../assets/icons/calendar-icon.svg"> {{ sanitizeCreationDate(service.dateScheduled) }}</span>
                        }
                        @if (service.dateExecuted != null) {
                          <span class="small"><img src="../../../assets/icons/check-icon.svg"> {{ sanitizeCreationDate(service.dateExecuted) }}</span>
                        }
                      </div>
                      @if (service.dateExecuted != null && ('Permissions.Services.Create' | permission)) {
                        <div class="user">
                          <img src="../../../assets/icons/profile-icon.svg"><span>{{ service.maintainerFirstName + ' ' + service.maintainerLastName }}</span>
                        </div>
                      }
                      @if (service.dateExecuted != null && !('Permissions.Services.Create' | permission) && service.type == 20) {
                        <div class="user">
                          <img src="../../../assets/icons/profile-icon.svg"><span>{{ service.maintainerFirstName + ' ' + service.maintainerLastName }}</span>
                        </div>
                      }
                    </div>
                    <div class="serviceProperty flexColumn" [hidden]="service.type == 20">
                      <span>{{ t('status') }}</span>
                      <span class="flexRow">{{ getStatusByValue(service.status)?.text }}
                        @if (service.status == 30) {
                          <span [attr.tooltip]="service.cancellationMessage" flow="right" class="tooltipContainer">
                            <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                          </span>
                        }
                      </span>
                    </div>
                    <div class="serviceProperty flexColumn" [hidden]="service.type == 20">
                      <span>{{ t('deviceWear') }}</span>
                      <span>{{ getDeviceWearByValue(service.deviceWear)?.text }}</span>
                    </div>
                    <div class="serviceProperty flexColumn" [hidden]="service.type == 20">
                      <span>{{ t('devicePollution') }}</span>
                      <span>{{ getDevicePollutionByValue(service.devicePollution)?.text }}</span>
                    </div>
                    <div class="serviceProperty flexColumn" [hidden]="service.type == 20">
                      <span>{{ t('imageCount') }}</span>
                      <span>{{ getImageCount(service) }}</span>
                    </div>
                    <div class="serviceProperty flexColumn large" [hidden]="service.type == 20">
                      <span>{{ t('remark') }}</span>
                      <span>{{ service.remark }}</span>
                    </div>
                    <div class="flexRow align-center serviceActionCol">
                      <a
                        [routerLink]="baseUrl + [service.revisionId]"
                        [attr.tooltip]="t('open')"
                        [hidden]="!isAdmin || !service.revisionId"
                        flow="up"
                        class="actionIcon">
                        <img src="../../../assets/icons/open-link-icon.svg">
                      </a>
                      <a
                        class="buttonSecondary"
                        [hidden]="((service.type != 20) && !('Permissions.Services.Delete' | permission)) || ((service.type == 20) && !('Permissions.ClientServices.Delete' | permission)) || service.revisionRevisionStatus?.isFinalStatus"
                        [attr.tooltip]="t('edit')"
                        flow="up"
                        class="actionIcon"
                        (click)="editService(service)">
                        <img src="../../../assets/icons/edit-icon.svg">
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="xs12col justify-center">
              @if (vm.loading) {
                <div class="loading-container">
                  <div class="k-loading-color"></div>
                  <kendo-loader type="converging-spinner" size="large"></kendo-loader>
                </div>
              }
            </div>
          </fieldset>
        </div>
      </form>
    }
  </ng-container>